var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4457 9.78038C20.4457 12.235 18.4559 14.2248 16.0013 14.2248C13.5467 14.2248 11.5569 12.235 11.5569 9.78038C11.5569 7.32578 13.5467 5.33594 16.0013 5.33594C18.4559 5.33594 20.4457 7.32578 20.4457 9.78038Z",
    fill: "#9756DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8532 12.7433C27.8532 14.3797 26.5266 15.7063 24.8902 15.7063C23.2538 15.7063 21.9272 14.3797 21.9272 12.7433C21.9272 11.1069 23.2538 9.78038 24.8902 9.78038C26.5266 9.78038 27.8532 11.1069 27.8532 12.7433Z",
    fill: "#9756DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9272 23.1137C21.9272 19.8409 19.2741 17.1878 16.0013 17.1878C12.7285 17.1878 10.0754 19.8409 10.0754 23.1137V27.5582H21.9272V23.1137Z",
    fill: "#9756DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0754 12.7433C10.0754 14.3797 8.74881 15.7063 7.11241 15.7063C5.47601 15.7063 4.14945 14.3797 4.14945 12.7433C4.14945 11.1069 5.47601 9.78038 7.11241 9.78038C8.74881 9.78038 10.0754 11.1069 10.0754 12.7433Z",
    fill: "#9756DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8902 27.5582V23.1137C24.8902 21.552 24.4875 20.0844 23.7802 18.809C24.135 18.7178 24.5069 18.6693 24.8902 18.6693C27.3448 18.6693 29.3346 20.6591 29.3346 23.1137V27.5582H24.8902Z",
    fill: "#9756DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22243 18.809C7.51515 20.0844 7.11241 21.552 7.11241 23.1137V27.5582H2.66797V23.1137C2.66797 20.6591 4.65781 18.6693 7.11241 18.6693C7.49569 18.6693 7.86763 18.7178 8.22243 18.809Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotion-icon.19cfbcdc878308af245c1f10293348d2.svg";
export { ForwardRef as ReactComponent };